import { MarketRateCheckButton, MarketRateDialog } from '#/features/market-rate'
import { PriceCell } from '#/shared/ui/table-cells'
import { useShipmentTariffEditor } from '../lib/use-shipment-tariff-editor'
import type { ShipmentStage } from '../model/stages'

interface ShipmentTariffCellProps {
  shipmentId: string
  tariff?: number
  deposit?: number
  /**
   * When set, saving the tariff promotes the shipment to this stage in a single
   * convert request. Used on the leads table where editing the tariff turns the
   * lead into a quote.
   */
  convertToStage?: ShipmentStage
}

export function ShipmentTariffCell({
  shipmentId,
  tariff,
  deposit,
  convertToStage,
}: ShipmentTariffCellProps) {
  const editor = useShipmentTariffEditor({
    shipmentId,
    deposit,
    convertToStage,
  })
  const { marketRate } = editor

  // The dialog and rate-check card portal to <body> but still bubble their
  // clicks through the React tree — without this the row's onClick fires on
  // close and opens the detail sidebar. Stop it at the cell root.
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <PriceCell
        value={tariff}
        seedValue={editor.seededPrice}
        onSave={editor.save}
        isPending={editor.isPending}
        onPriceIconClick={() => marketRate.setOpen(true)}
        rateCheckSlot={
          <MarketRateCheckButton
            shipmentId={shipmentId}
            onUsePrice={editor.seedPrice}
          />
        }
      />
      <MarketRateDialog
        open={marketRate.open}
        onOpenChange={marketRate.setOpen}
        stats={marketRate.stats}
        rows={marketRate.rows}
        isLoading={marketRate.isLoading}
        errorMessage={marketRate.errorMessage}
        onUseRate={marketRate.onUseRate}
      />
    </div>
  )
}
